import OpsIcon from "./OpsIcon";
export default OpsIcon;